var map = {
	"./es": [
		95,
		28
	],
	"./es.json": [
		95,
		28
	],
	"./fr": [
		96,
		29
	],
	"./fr.json": [
		96,
		29
	],
	"./it": [
		18
	],
	"./it.json": [
		18
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 97;
module.exports = webpackAsyncContext;